module.exports = "table, th, td {\n    border: 1px solid black;\n    border-collapse: collapse;\n}"